import React from 'react';
import img from '~/components/Layout/searchSections.jpg';

const Background = (props) => (
  <div
    className="searchSections-background"
    {...props}
    style={{ backgroundImage: `url(${img})` }}
  />
);

export default Background;
